import { render, staticRenderFns } from "./navigation-item.vue?vue&type=template&id=37c5596d&"
import script from "./navigation-item.vue?vue&type=script&lang=js&"
export * from "./navigation-item.vue?vue&type=script&lang=js&"
import style0 from "./navigation-item.vue?vue&type=style&index=0&id=37c5596d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports